<template lang="pug">
div
    div(
        v-if="sectionTitle && tip"
    )
        div(class="flex items-center gap-2")
            h2(class="title-h4 text-opaq")
                slot
            i.mi-circle-information(
                v-tooltip.top="tip"
                style="font-size: 20px; opacity: 0.3"
            )
        div(class="h-4")
    div(
        v-else-if="sectionTitle"
    )
        h2(class="title-h4 text-opaq")
            slot
        div(class="h-1")

    div(
        v-else-if="cardTitle"
    )
        h2(class="title-h4")
            slot
        div(class="h-1")

    div(
        v-else-if="cardDescription"
    )
        p(class="text-base text-muted-foreground")
            slot
        div(class="h-1")

    div(
        v-else-if="dialogTitle"
    )
        .dialog-title-wrapper
            h2(class="title-h3")
                slot
            .close-icon(
                v-if="closeIcon"
                @click="emit('close-click')"
            )
                i.mi-close

        div(
            v-if="description"
        )
            p(
class="text-base text-muted-foreground"
style="margin-top: 3px") {{ description }}

        div(class="h-1")

    div(
        v-else-if="listTitle"
    )
        h3(class="text-xs text-muted-foreground uppercase")
            slot
        div(class="h-1")

    div(
        v-else
    )
        slot
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    sectionTitle: Boolean,
    dialogTitle: Boolean,
    listTitle: Boolean,
    cardTitle: Boolean,
    cardDescription: Boolean,
    description: String,
    tip: String,
    closeIcon: Boolean,
})

const sectionTitle = computed(() => !!props.sectionTitle)
const dialogTitle = computed(() => !!props.dialogTitle)
const listTitle = computed(() => !!props.listTitle)
const cardTitle = computed(() => !!props.cardTitle)
const cardDescription = computed(() => !!props.cardDescription)

const emit = defineEmits(['close-click'])
</script>

<style lang="sass" scoped>
.dialog-title-wrapper
    position: relative

.close-icon
    position: absolute
    right: 0
    top: 50%
    transform: translateY(-50%)
    font-size: 24px
    cursor: pointer
</style>
